import axiosInstance from "./axios-service/axiosInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
};

const roleService = {
  fetchAllRoles: () => {
    return axiosInstance.get(
      "/itl_rolemasters?$select=createdon,itl_name,statecode&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  fetchAllActiveRoles: () => {
    return axiosInstance.get(
      "/itl_rolemasters?$select=createdon,itl_name,statecode&$filter=statecode eq 0&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  updateRole: async (id, obj) => {
    return axiosInstance.patch(`/itl_rolemasters(${id})`, obj, {
      headers: headers,
    });
  },

  addRole: async (obj) => {
    return axiosInstance.post("/itl_rolemasters", obj, {
      headers: headers,
    });
  },
};

export default roleService;
